/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import ChatMessageBody, {
  type Props as ChatMessageBodyProps,
} from 'bundles/ai-coach-platform/components/patterns/chat/common/messages/ChatMessageBody';

const styles = {
  message: css`
    padding: var(--cds-spacing-100) var(--cds-spacing-100) 0 var(--cds-spacing-100);
  `,
};

const CourseraAiTemporaryStreamedMessage = (props: ChatMessageBodyProps) => {
  return <ChatMessageBody {...props} css={styles.message} />;
};

export default CourseraAiTemporaryStreamedMessage;
